import * as Models from '../../models/commonModels';

export class GetAttachmentType {
  static readonly type = '[Dictionary] Get Attachment Type';
  constructor() { }
}

export class GetAfterSalesPeriod {
  static readonly type = '[Dictionary] Get After Sales Periods';
  constructor() { }
}

export class GetAdministratorRoles {
  static readonly type = '[Dictionary] Get Administrator Roles';
  constructor() { }
}

export class GetCustomers {
  static readonly type = '[Dictionary] Get Customers';
  constructor(public OnlyMy: boolean = false, public GarageId: number = null) { }
}

export class GetCustomerRoles {
  static readonly type = '[Dictionary] Get Customer Roles';
  constructor() { }
}

export class GetInvoiceTypes {
  static readonly type = '[Dictionary] Get Invoice Types';
  constructor() { }
}

export class GetInvoiceStatuses {
  static readonly type = '[Dictionary] Get Invoice Statuses';
  constructor() { }
}

export class GetExternalCustomers {
  static readonly type = '[Dictionary] Get External Customers';
  constructor() { }
}

export class GetAddressesDictionary {
  static readonly type = '[Dictionary] Get Addresses Dictionary';
  constructor() { }
}

export class GetWorkers {
  static readonly type = '[Dictionary] Get Workers';
  constructor() { }
}

export class GetCustomerInvoiceSeparateByType {
  static readonly type = '[Dictionary] Get CustomerInvoiceSeparateByType';
  constructor() { }
}

export class GetCourierParcelWeight {
  static readonly type = '[Dictionary] Get Courier Parcel Weight';
  constructor() { }
}

export class GetCourierParcelValues {
  static readonly type = '[Dictionary] Get Courier Parcel Values';
  constructor() { }
}

export class GetCourierGarageOrderDelayDays {
  static readonly type = '[Dictionary] Get Courier Garage Order Delay Days';
  constructor() { }
}

export class GetPaymentTypes {
  static readonly type = '[Dictionary] Get Payment Types';
  constructor() { }
}

export class GetGarages {
  static readonly type = '[Dictionary] Get Garages';
  constructor() { }
}

export class GetCars {
  static readonly type = '[Dictionary] Get Registration Number';
  constructor(public RegistrationNumber: string) { }
}

export class GetCarBrands {
  static readonly type = '[Dictionary] Get Car Brands';
  constructor() { }
}

export class GetCarModels {
  static readonly type = '[Dictionary] Get Car Models';
  constructor(public CarBrandlId: number) { }
}

export class GetCarTypes {
  static readonly type = '[Dictionary] Get Car Types';
  constructor(public CarModelId: number) { }
}

export class GetCostEstimationStatus {
  static readonly type = '[Dictionary] Get Cost Estimation Status';
  constructor() { }
}

export class GetGaragePlaceType {
  static readonly type = '[Dictionary] Get Garage Place Type';
  constructor() { }
}

export class GetAPIRights {
  static readonly type = '[Dictionary] Get API Rights';
  constructor() { }
}

export class GetAPIServices {
  static readonly type = '[Dictionary] Get API Services';
  constructor() { }
}

export class GetGarageInvoiceStatuses {
  static readonly type = '[Dictionary] Get Garage Invoice Statuses';
  constructor() { }
}

export class GetMessageTypes {
  static readonly type = '[Dictionary] Get Message Types';
  constructor() { }
}

export class GetEmailTypes {
  static readonly type = '[Dictionary] Get Email Types';
  constructor() { }
}

export class GetKsefInvoiceCostStatuses {
  static readonly type = '[Dictionary] Get Ksef Invoice Cost Statuses';
  constructor() { }
}

export class GetKSeFInvoiceTypes {
  static readonly type = '[Dictionary] Get Ksef Invoice Types';
  constructor() { }
}

export class GetKSeFVatRates {
  static readonly type = '[Dictionary] Get Ksef Vat Rates';
  constructor() { }
}

export class GetServiceCostTypes {
  static readonly type = '[Dictionary] Get Service Cost Types';
  constructor() { }
}

export class GetKsefInvoiceSaleStatuses {
  static readonly type = '[Dictionary] Get Ksef Invoice Sale Statuses';
  constructor() { }
}

export class GetInvoiceKSeFStatuses {
  static readonly type = "[Dictionary] GetInvoiceKSeFStatuses";
  constructor() { }
}
